
    import Vue from 'vue';

    export default Vue.extend({
      name: 'RomaModalTop',
      props: {
        height: {
          type: String,
          required: true,
        },
      },
    });
